var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinbaseWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 188,
    viewBox: "0 0 540 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H524C532.837 0 540 7.16344 540 16V172C540 180.837 532.837 188 524 188H16C7.16345 188 0 180.837 0 172V16Z",
    fill: "#73A2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.133 71.6667H178V149.833H160.133V71.6667Z",
    fill: "#5DE2F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71.6667H52.9333V149.833H44V71.6667Z",
    fill: "#5DE2F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.533 44.5177C96.4732 44.5177 88.3177 52.6731 88.3177 62.7333C88.3177 72.7935 96.4732 80.949 106.533 80.949C116.594 80.949 124.749 72.7935 124.749 62.7333C124.749 52.6731 116.594 44.5177 106.533 44.5177ZM91.249 62.7333C91.249 54.292 98.092 47.449 106.533 47.449C114.975 47.449 121.818 54.292 121.818 62.7333C121.818 71.1747 114.975 78.0177 106.533 78.0177C98.092 78.0177 91.249 71.1747 91.249 62.7333Z",
    fill: "#101114"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 98.4667H178V125.267H133.333V98.4667Z",
    fill: "#0052FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8 62.7333C70.8 42.9984 86.7984 27 106.533 27C126.268 27 142.267 42.9984 142.267 62.7333H160.133V161H52.9333V62.7333H70.8ZM84.2 62.7333H128.867C128.867 50.399 118.868 40.4 106.533 40.4C94.199 40.4 84.2 50.399 84.2 62.7333Z",
    fill: "#CED2DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9333 71.6667H160.133V149.833H52.9333V71.6667Z",
    fill: "#0052FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.4 111.867C124.4 104.466 130.399 98.4667 137.8 98.4667H160.133V125.267H137.8C130.399 125.267 124.4 119.267 124.4 111.867Z",
    fill: "#0A0B0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.917 118.567C142.617 118.567 145.617 115.567 145.617 111.867C145.617 108.166 142.617 105.167 138.917 105.167C135.216 105.167 132.217 108.166 132.217 111.867C132.217 115.567 135.216 118.567 138.917 118.567ZM138.917 120.8C143.85 120.8 147.85 116.8 147.85 111.867C147.85 106.933 143.85 102.933 138.917 102.933C133.983 102.933 129.983 106.933 129.983 111.867C129.983 116.8 133.983 120.8 138.917 120.8Z",
    fill: "#0052FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9014 104.818H63.9702V109.328L60.0641 107.073L58.5985 109.612L62.5042 111.867L58.5983 114.122L60.0639 116.66L63.9702 114.405V118.916H66.9014V114.405L70.8077 116.661L72.2733 114.122L68.3667 111.867L72.273 109.611L70.8074 107.073L66.9014 109.328V104.818Z",
    fill: "#0A0B0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2347 104.818H86.3035V109.328L82.3975 107.073L80.9318 109.612L84.8375 111.867L80.9316 114.122L82.3972 116.66L86.3035 114.405V118.916H89.2347V114.405L93.141 116.661L94.6066 114.122L90.7 111.867L94.6064 109.611L93.1408 107.073L89.2347 109.328V104.818Z",
    fill: "#0A0B0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.006 104.818H109.075V109.328L105.169 107.073L103.704 109.612L107.609 111.867L103.703 114.122L105.169 116.66L109.075 114.405V118.916H112.006V114.405L115.913 116.661L117.378 114.122L113.472 111.867L117.378 109.611L115.912 107.073L112.006 109.328V104.818Z",
    fill: "#0A0B0D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2236_8217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.954 47H314V128.467H476.954V47Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 59.6117H339.202V141.078H502V59.6117Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.954 59.6117H339.202V128.545H476.954V59.6117Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.562 115.933C385.622 115.933 395.399 106.149 395.399 94.0784C395.399 82.0082 385.622 72.2234 373.562 72.2234C361.502 72.2234 351.725 82.0082 351.725 94.0784C351.725 106.149 361.502 115.933 373.562 115.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.327 94.94C377.391 94.94 380.684 91.6433 380.684 87.5766C380.684 83.51 377.391 80.2133 373.327 80.2133C369.264 80.2133 365.97 83.51 365.97 87.5766C365.97 91.6433 369.264 94.94 373.327 94.94Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.627 97.1334C412.07 97.1334 408 93.295 408 87.89C408 82.6417 411.913 78.4117 417.784 78.4117C423.027 78.4117 426.784 82.015 426.784 87.0283C426.784 90.5533 424.984 92.59 422.48 92.59C420.993 92.59 419.897 91.885 419.584 90.71C419.114 91.885 418.018 92.6684 416.453 92.6684C414.418 92.6684 413.009 91.5717 413.009 89.8484C413.009 88.0467 414.418 87.185 416.844 86.95L417.862 86.8717C418.644 86.7934 418.958 86.48 418.958 86.01C418.958 85.4617 418.566 84.9917 417.627 84.9917C416.609 84.9917 416.14 85.3834 416.14 86.0884H413.322C413.557 84.2867 415.044 83.0333 417.627 83.0333C419.818 83.0333 421.775 83.895 421.775 86.5584V89.6134C421.775 90.3184 422.167 90.71 422.714 90.71C423.81 90.71 424.436 89.065 424.436 87.185C424.436 83.2683 421.619 80.7617 417.784 80.7617C413.479 80.7617 410.505 83.8167 410.505 88.0467C410.505 92.355 413.635 95.0967 417.705 95.0967C419.349 95.0967 420.523 94.7833 421.54 94.3917V96.585C420.445 96.8983 419.192 97.1334 417.627 97.1334ZM418.958 88.2033C418.801 88.36 418.41 88.5167 418.018 88.5167L417.314 88.595C416.375 88.6733 415.905 89.065 415.905 89.6134V89.6917C415.905 90.1617 416.296 90.5533 417.157 90.5533C418.41 90.5533 419.036 89.77 419.036 88.595V88.2033H418.958Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.157 103.478H464.431",
    stroke: "black",
    strokeWidth: 1.425,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.157 109.745H464.353",
    stroke: "black",
    strokeWidth: 1.425,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.157 116.012H448.465",
    stroke: "black",
    strokeWidth: 1.425,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.64 97.2117C366.048 97.2117 359.787 102.538 358.3 109.667C362.213 113.505 367.614 115.933 373.562 115.933C379.589 115.933 384.989 113.505 388.903 109.588C387.415 102.46 381.154 97.2117 373.64 97.2117Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.431 84.6783H433.124V90.945H464.431V84.6783Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.954 59.6117H339.202V65.8783H476.954V59.6117Z",
    fill: "black"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.445 87H205V91.2333H209.445V87Z",
    fill: "#CED2DB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.569 87H218.124V91.2333H222.569V87Z",
    fill: "#CED2DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.904 87H231.458V91.2333H235.904V87Z",
    fill: "#CED2DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M249.027 87H244.582V91.2333H249.027V87Z",
    fill: "#CED2DB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M262.149 87H257.704V91.2333H262.149V87Z",
    fill: "#CED2DB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M275.273 87H270.828V91.2333H275.273V87Z",
    fill: "#CED2DB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M288.608 87H284.163V91.2333H288.608V87Z",
    fill: "#CED2DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.445 102H205V106.233H209.445V102Z",
    fill: "#CED2DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M222.569 102H218.124V106.233H222.569V102Z",
    fill: "#CED2DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M235.904 102H231.458V106.233H235.904V102Z",
    fill: "#CED2DB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M249.027 102H244.582V106.233H249.027V102Z",
    fill: "#CED2DB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M262.149 102H257.704V106.233H262.149V102Z",
    fill: "#CED2DB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.273 102H270.828V106.233H275.273V102Z",
    fill: "#CED2DB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M288.608 102H284.163V106.233H288.608V102Z",
    fill: "#CED2DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2236_8217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 94,
    fill: "white",
    transform: "translate(314 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseWallet);
export default __webpack_public_path__ + "static/media/Coinbase-Wallet.5098ead619e9ecf189a9cea8cd68018f.svg";
export { ForwardRef as ReactComponent };